import React from 'react';

const Helix = (props)=> {
    let num = props.num;
    let innerDivs = [];
    for (let i = num; i >= 0; i--){
        innerDivs.push(<div key={i + "L"} className={`helixL-${i}`}></div>);
        innerDivs.push(<div key={i + "R"} className={`helixR-${i}`}></div>);
    }
    return (
        <div id="helix">
            {innerDivs}
        </div>
       
    )
}

export default Helix;